import { List, ListSubheader } from '@mui/material';
import { MenuWithChildren } from '../../../types/menu';
import { MobileHeaderMenuItem } from './MobileHeaderMenuItem';

interface MobileHeaderMenuListProps {
  menus: MenuWithChildren[];
  subHeader: string;
  subHeaderId: string;
}

export const MobileHeaderMenuList: React.FC<MobileHeaderMenuListProps> = ({ menus, subHeader, subHeaderId }) => {
  return (
    <List
      component="nav"
      aria-labelledby={subHeaderId}
      subheader={
        <ListSubheader sx={{ mb: 0.5 }} component="div" id={subHeaderId}>
          {subHeader}
        </ListSubheader>
      }
    >
      {menus.map((menu) => (
        <MobileHeaderMenuItem key={menu.id} menu={menu} />
      ))}
    </List>
  );
};
